module.exports = __webpack_public_path__ + "static/media/illuipm.89adb595.png";